var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 811419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8188 12.5146V16.273V16.3356C17.8188 17.5884 16.7539 18.5907 15.5011 18.5907H10.1141H7.23266L3.22371 21.4721L3.09844 18.5907C1.84564 18.5907 0.780762 17.5258 0.780762 16.273V9.00676C0.780762 7.69132 1.783 6.68909 3.09844 6.68909H12.1812",
    stroke: "black",
    strokeWidth: 1.1344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8188 16.3983H22.3289C23.3938 16.3983 24.2081 17.2753 24.2081 18.3402V24.3536C24.2081 25.4185 23.3311 26.2954 22.3289 26.2954L22.2036 28.6131L18.8837 26.2328H12.056C10.9911 26.2328 10.1768 25.3558 10.1768 24.2909V18.5907M26.8389 12.5147L26.7137 15.3961L22.7047 12.5147H14.4363C13.1835 12.5147 12.1186 11.4498 12.1186 10.197V2.93077C12.1186 1.61534 13.1208 0.613098 14.4363 0.613098H26.9016C28.1544 0.613098 29.2193 1.67797 29.2193 2.93077V10.197C29.2193 11.5124 28.1544 12.5147 26.8389 12.5147Z",
    stroke: "black",
    strokeWidth: 1.1344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8188 16.3983H22.3289C23.3938 16.3983 24.2081 17.2753 24.2081 18.3401V24.3536C24.2081 25.4185 23.3311 26.2954 22.3289 26.2954L22.2036 28.6131L18.8837 26.2328H12.056C10.9911 26.2328 10.1768 25.3558 10.1768 24.2909V18.5907L17.8188 16.3983Z",
    fill: "#E8222A",
    stroke: "#333333",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.3745 20.5325H20.0121",
    stroke: "white",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.3745 22.9755H20.0121",
    stroke: "white",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.8188 12.5146V16.273V16.3356C17.8188 17.5884 16.7539 18.5907 15.5011 18.5907H10.1141H7.23266L3.22371 21.4721L3.09844 18.5907C1.84564 18.5907 0.780762 17.5258 0.780762 16.273V9.00676C0.780762 7.69132 1.783 6.68909 3.09844 6.68909H12.1812L17.8188 12.5146Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.8383 12.5147L26.713 15.3961L22.7041 12.5147H14.4356C13.1828 12.5147 12.1179 11.4498 12.1179 10.197V2.93077C12.1179 1.61534 13.1202 0.613098 14.4356 0.613098H26.9009C28.1537 0.613098 29.2186 1.67797 29.2186 2.93077V10.197C29.2186 11.5124 28.1537 12.5147 26.8383 12.5147Z",
    fill: "#F86C66",
    stroke: "#333333",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.0659 5.24841H24.2695",
    stroke: "white",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.0659 7.94189H24.2695",
    stroke: "white",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavMessage);
export default __webpack_public_path__ + "static/media/sidenav_message.46a3e9f64c4c71d7943a8d7fc3658d8e.svg";
export { ForwardRef as ReactComponent };